const resources = [
  {
    category: "Passport Photo Locations",
    icon: "ri-camera-line",
    items: [
      { name: "Walgreens – Bismarck", detail: "Multiple locations in Bismarck" },
      { name: "CVS Photo – Bismarck", detail: "Passport photos while you wait" },
      { name: "Walmart Supercenter", detail: "2504 State St, Bismarck — low cost option" },
      { name: "Target – Bismarck", detail: "701 S 12th St, Bismarck" },
    ],
  },
  {
    category: "North Dakota DMV",
    icon: "ri-id-card-line",
    items: [
      { name: "ND Dept. of Transportation", detail: "nddot.gov — driver licenses and state IDs" },
      { name: "Bismarck Driver License Site", detail: "1600 E Century Ave, Bismarck" },
      { name: "ND REAL ID Info", detail: "nddot.gov/dmv/license-id/real-id" },
      { name: "Mandan DL Office", detail: "Serves Mandan and west bank residents" },
    ],
  },
  {
    category: "Bismarck Airport Info",
    icon: "ri-plane-line",
    items: [
      { name: "Bismarck Municipal Airport", detail: "2301 University Dr, Bismarck, ND 58504" },
      { name: "Airport Code", detail: "BIS — serves central North Dakota" },
      { name: "Direct Flights", detail: "Minneapolis, Denver, Chicago, Dallas" },
      { name: "TSA PreCheck", detail: "Available at BIS — speeds up security screening" },
    ],
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Passport Resources in Bismarck
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything you need to get your passport ready for travel from the Bismarck area.
          </p>
        </div>

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {resources.map((r, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                    <i className={`${r.icon} text-[#1A365D]`}></i>
                  </div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{r.category}</h3>
                </div>
                <ul className="space-y-3">
                  {r.items.map((item, j) => (
                    <li key={j} className="border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                      <p className="font-semibold text-[#1A365D] text-xs">{item.name}</p>
                      <p className="text-gray-400 text-xs mt-0.5">{item.detail}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Birth, Death, Marriage &amp; Divorce Records — Bismarck</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                If you need a certified copy of your birth certificate for a passport application, a marriage certificate for a name change, or a divorce decree to support your passport correction, here are the official sources for vital records for Bismarck residents.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <a href="https://www.hhs.nd.gov/vital" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                    <i className="ri-user-heart-line text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">Birth Certificates</p>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1.5">North Dakota Department of Health — Vital Records. Order online, by mail, or in person.</p>
                    <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span>
                  </div>
                </a>
                <a href="https://www.hhs.nd.gov/vital" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                    <i className="ri-heart-pulse-line text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">Death Certificates</p>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1.5">Certified copies available through ND Vital Records. Required for some passport applications.</p>
                    <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span>
                  </div>
                </a>
                <a href="https://www.hhs.nd.gov/vital" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                    <i className="ri-links-line text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">Marriage Certificates</p>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1.5">Burleigh County Recorder or ND Vital Records. Needed for name change on passport.</p>
                    <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span>
                  </div>
                </a>
                <a href="https://www.ndcourts.gov/" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                    <i className="ri-scales-3-line text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">Divorce Decrees</p>
                    <p className="text-gray-500 text-xs leading-relaxed mb-1.5">North Dakota District Court — Burleigh County. Contact the Clerk of Court for certified copies.</p>
                    <span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span>
                  </div>
                </a>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-information-line text-amber-500 mr-1.5"></i>
                  <strong>Don&apos;t see your county?</strong> If the record you need was issued outside the area, visit <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">VitalChek.com</a> — the official online service for ordering vital records nationwide across all U.S. states and counties.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}